import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { socketConnect } from 'socket.io-react';
import PropTypes from 'prop-types';
import { browserHistory, Link } from 'react-router';
import { userLogin } from 'store/user';
import Modal from 'components/Modal';
import InputValidation from 'components/InputValidation';
import { spin, stop } from 'store/spinner';
import LogoImage from 'assets/megafit-images/mf-logo.svg';
import bannerOtpAuth from 'assets/megafit-images/sign-banner.png';
import LogoImageIcon from 'assets/megafit-images/mf-logo.svg';
import DietPlanIcon from 'assets/megafit-images/diat-plan.gif';
import MasterIcon from 'assets/mastercard.svg';
import PhoneInput from 'components/PhoneInput';
import PureCheckBox from 'components/PureCheckBox';
import VisaIcon from 'assets/visa.svg';
import { parsePhoneNumber } from 'react-phone-number-input';
class OtpAuth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      validateType: 'phone',
      showsms: false,
      errorModalMessage: '',
      errors: {},
      xyz: false,
      otp: ['','','',''],
      step: 1,         // 1 = enter contact, 2 = enter OTP
      timer: 0,        // countdown timer
      intervalId: null, // stores interval for clearing,
      first_name:'',
      last_name:'',
      sameaswhatsapp:1,
      phone:'',
      whatsUpnumber:'',
      WPC_CODE:'',
      PC_CODE:'+971',
    };
    this.otpInputs = [];
  }

  socketLogin = ({ type, data, message,status }) => {
    // console.debug(type);
    // console.debug(data);
    // console.debug(message);
    this.props.stop();
    if (this.OtpAuthRef) {
      switch (type) {
        case 'otpErr':
        case 'otpverifyErr':
          this.setState({
            errorModalMessage: message,
          });
        break;
        case 'createAccountErr':
          this.setState({ errors: data });
        break;
        case 'otpOk':
          this.setState({
            step:2
          });
          this.startTimer();
        break;
        case 'otpverifyOk':
          clearInterval(this.state.intervalId);
          this.setState({
            step:3,
            timer:0
          });
        break;
        case 'setOk':
          case 'createAccountOk':
          this.props.login(data);
          browserHistory.push('/');
        break;
      }
    }
  };

  componentWillMount() {
    clearInterval(this.state.intervalId);
    this.props.socket.on('login', this.socketLogin);
    this.props.socket.on('registration', this.socketLogin);
  }

  componentWillUnmount() {
    this.props.socket.removeListener('login', this.socketLogin);
    this.props.socket.removeListener('registration', this.socketLogin);
  }

  componentDidMount() {
    setTimeout(() => this.setState({ xyz: true }), 10);
  }
 

  handleOtpChange = (name,value) => {
    const val = value.replace(/[^0-9]/g, '').slice(0, 4);
    this.setState({ otp: val});
  };
  handleOtpChange = (value, index) => {
    if (/^\d?$/.test(value)) { // allow only single digit
      const otp = [...this.state.otp];
      otp[index] = value;
      this.setState({ otp }, () => {
        if (value && index < 3) {
          this.otpInputs[index + 1].focus(); // auto move to next box
        }
      });
    }
  };

  handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !this.state.otp[index] && index > 0) {
      this.otpInputs[index - 1].focus(); // move back if empty
    }
  };
  startTimer = () => {
    const intervalId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timer <= 1) {
          clearInterval(this.state.intervalId);
          return { timer: 0, intervalId: null,step:4 };
        }
        return { timer: prevState.timer - 1 };
      });
    }, 1000);
    this.setState({ timer: 300, intervalId });
  };
  sendOtp = (validateType,contact,PC_CODE,browserId) => {
    try {
      this.props.spin();
      this.props.socket.emit('login', { type: 'otp', data: { validateType,contact,PC_CODE, app: 'customer',browserId } });
      // this.setState({ step: 2 });
      
    } catch (error) {
      alert('Failed to send OTP');
    }
  };

  verifyOtp = (browserId) => {
    try {
      const { otp,validateType,email,phone,PC_CODE } = this.state;
      let contact = (validateType=='email')?email:phone;
      this.props.spin();
      this.props.socket.emit('login', { type: 'otpverify', data: { validateType,contact,otp:otp.join(''),PC_CODE:PC_CODE, app: 'customer',browserId } });
    } catch (error) {
      alert('Error verifying OTP');
    }
  };
  passwordGenerator(includeNumbers,includeSpecialChars){
    const lowercaseChars = "abcdefghijklmnopqrstuvwxyz";
    const uppercaseChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numberChars = "0123456789";
    const specialChars = "!@#$%^&*()_+-=[]{}|;:,.<>?";
    let allChars = lowercaseChars + uppercaseChars; // Start with default
    if (includeNumbers) {
        allChars += numberChars;
    }
    if (includeSpecialChars) {
        allChars += specialChars;
    }
    let password = "";
    const passwordLength = 12; // Example length
    for (let i = 0; i < passwordLength; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        password += allChars[randomIndex];
    }
    return password;
  }
  submit(e, browserId) {
    e.preventDefault();
    const { email, otp,step, validateType,PC_CODE } = this.state;
    let phone =this.state.phone ;
    if(step==1 || step==4){
        let contact = (validateType=='email')?email:phone;
        if(step==4){
          this.setState({otp:['','','','']});
        }
        this.sendOtp(validateType,contact,PC_CODE,browserId);
    }else if(step==2){
      this.verifyOtp(browserId);
    }else if(step==3){
      const { referer, first_name, last_name,sameaswhatsapp} = this.state;
      let whatsUpnumber =(sameaswhatsapp)?this.state.phone:this.state.whatsUpnumber;
      let phoneCode ='';
      let whatCode ='';
      if(whatsUpnumber!='' && whatsUpnumber!=null){
        let phcode = parsePhoneNumber(whatsUpnumber);
        whatCode= (phcode)?'+'+phcode.countryCallingCode:null;
        whatsUpnumber=phcode.nationalNumber;
      }
      if(phone!='' && phone!=null ){
        let phcode =parsePhoneNumber(phone);
        phoneCode= (phcode)?'+'+phcode.countryCallingCode:null;
        phone=phcode.nationalNumber;
      }
      const password = this.passwordGenerator(true,false);
      this.props.spin();
      this.props.socket.emit('registration', { type: 'createAccount', data: { email, first_name:first_name,last_name:last_name, password:password, referer, PC_CODE:phoneCode, WPC_CODE:whatCode, phone, whatsUpnumber, browserId } });
    }
   
  }

  render() {
    const onChange = (name, value) => this.setState({ [name]: value });
    const onPhoneChange = (name, value) =>{
      this.setState({ [name]: value });
      if(sameaswhatsapp){
        this.setState({ 'whatsUpnumber': value });
      }
    };
    const { errors, errorModalMessage, email, showsms, validateType,phone, first_name,last_name,whatsUpnumber,WPC_CODE,PC_CODE,sameaswhatsapp, step,otp,timer  } = this.state;
    console.debug(PC_CODE);
    const { settings, browserId,stop} = this.props;
    let buttonText = (step==1)?'Get OTP':((step==2)?'Verify OTP':((step==4)?'Resend OTP':'Create Account'));
    return (
      <div ref={el => (this.OtpAuthRef = el)} className={`mf-container`}>
      <div className='full-width'>
        <div className='sign-container'>
        <div className='sign-left'>
        <img src={bannerOtpAuth} alt='Megafit-Banner' />
            <div className='sign-left-inner '>
              <div className="flex-container">
                  <div className="sign-content-left">
                      <h1> 
                          <span className="mainSpan"><span className="small-txt">Customize</span><span className="normal-txt"> Your Fuel,</span></span>
                          <span className="mainSpan"><span className="small-txt">Maximize</span><span className="normal-txt"> Your Gains</span></span>
                      </h1>
                  </div>
                  <div className="sign-content-right">
                      <p>Make you own Macro <br/>Counted Meals with</p>
                      <span className="yellow-box"><strong>MegaFit</strong> CustomFit<sup>®</sup></span>
                  </div>    
              </div>
            </div>            
        </div>
        <div className={`sign-right`}>
          <div className="sigin-holder">
            <div className="logo-holder">
              <div className='logo'>  <Link to='/' onClick={() => stop()} onlyActiveOnIndex><img src={LogoImage} alt='Megafit' /></Link></div>
              <div className='logo-icon'>  <Link to='/' onClick={() => stop()} onlyActiveOnIndex><img src={LogoImageIcon} alt='Megafit' /></Link></div>   
            </div>
            <div className="form-holder">
              <div className="marquee">
                <img src={DietPlanIcon} alt='megaFit' />
                <div className="diet-text">
                  <p>Plan your menu and choose your meals completely free before starting.</p><p>Sign in to start, select your macros and see the dish options.</p> 
                </div>        
              </div>    
              <div className='sign-up-form signinform'>
                <div className='sign-in-top mt-1'>
                {validateType=='phone'?<span className={`colorTitle`}>Phone</span>:<a href="#" className={`colorTitle`} onClick={()=>{ this.setState({validateType:'phone',email:'',step:1})}}>Phone</a>}
                {validateType=='email'?<span className={`colorTitle ml-3`}>Email</span>:<a href="#" className={`colorTitle ml-3`} onClick={()=>{ this.setState({validateType:'email',phone:'',step:1})}}>Email</a>}
                </div>
                <form className='form' onSubmit={e => this.submit(e, browserId)}>
                  <div className='sign-form-container'>
                  {step==3 && <div className='sign-up-row mt-3 sign-name'>
                    <div className='sign-up-input'>
                      <label className="textLeft">First Name</label>
                      <InputValidation
                        value={first_name}
                        name='first_name'
                        onChange={onChange}
                        errors={errors}
                        placeholder='First Name'
                        inputSelfClassName='standart-input b-rounded-blue'
                      />
                    </div>
                    <div className='sign-up-input'>
                    <label className="textLeft">Last Name</label>
                      <InputValidation
                        value={last_name}
                        name='last_name'
                        onChange={onChange}
                        errors={errors}
                        placeholder='Last Name'
                        inputSelfClassName='standart-input b-rounded-blue'
                      />
                    </div>
                  </div>}

                  {(validateType=='email' ||step==3) && <div className='sign-up-input mt-3 email-field'><label className="textLeft">Email</label>
                    <InputValidation
                      value={email}
                      name='email'
                      onChange={onChange}
                      placeholder='Your Email'
                      errors={errors}
                      inputSelfClassName='standart-input b-rounded-blue'
                    />
                  </div>}
                 {(validateType=='phone' ||step==3) && <div className='sign-up-input mt-3 additional-number'><label className="textLeft">Phone Number</label>
                  <PhoneInput
                      errors={errors}
                      labelText={'Calling Number'}
                      classError='has-error letter-xs'
                        phoneProps={{ 
                              value:(PC_CODE!=null && PC_CODE!=undefined && phone!=undefined)?PC_CODE+(phone.replace(PC_CODE,'')):phone,
                              defaultCountry:"AE",
                              className:'standart-input b-rounded-blue',
                              // labels:{'phone':'Calling Number'},
                              name:'phone',
                              international:true,
                              placeholder:'Calling Number',
                              countryCallingCodeEditable:false,
                              onChange:(value) => onPhoneChange('phone', value)
                        }}
                      /></div>}
                   {step==3 && <Fragment> <div className='sign-up-input mt-3 additional-number'>
                          <div className='checkbox-con'>
                          <PureCheckBox value={sameaswhatsapp} id="sameaswhatsapp" name="sameaswhatsapp" onChange={(name,checked,val)=>{
                            this.setState({sameaswhatsapp:checked});
                            if(checked){
                              this.setState({phone:whatsUpnumber});
                            }
                          }} />
                          <div className='checkbox-label-con'>
                            <label className='checkbox-label' for="sameaswhatsapp">Same number for WhatsApp</label>
                          <span className='checkbox-sublabel'>All communication will be through WhatsApp</span>
                          </div>
                          </div>
                          </div>
                          {!sameaswhatsapp && <div className='sign-up-input mt-3'>
                                  <label className='textLeft'>WhatsApp Number</label>
                                  <PhoneInput
                                    classError='has-error letter-xs'
                                    errors={errors}
                                    labelText={'WhatsApp Number'}
                                    phoneProps={{ 
                                      value:(WPC_CODE!=null && WPC_CODE!=undefined && whatsUpnumber!=undefined)?WPC_CODE+(whatsUpnumber.replace(WPC_CODE,'')):whatsUpnumber,
                                        defaultCountry:"AE",
                                        international:true,
                                        name:'whatsUpnumber',
                                        placeholder:'WhatsApp Number',
                                        countryCallingCodeEditable:false,
                                        className:'standart-input b-rounded-blue',
                                        onChange:(value) => onChange('whatsUpnumber', value)
                                    }}
                                  />
                                </div>}</Fragment>}    
                  {step==2 && <div className='sign-up-input mt-3 email-field'><label className="textLeft">Enter OTP</label>
                    <div style={{ display: "flex", gap: "10px" }}>
                        {this.state.otp.map((digit, idx) => (
                          <input
                            key={idx}
                            className="standart-input b-rounded-blue"
                            ref={(el) => (this.otpInputs[idx] = el)}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) => this.handleOtpChange(e.target.value, idx)}
                            onKeyDown={(e) => this.handleKeyDown(e, idx)}
                            style={{
                              width: "50px",
                              height: "50px",
                              textAlign: "center",
                              fontSize: "24px"
                            }}
                          />
                        ))}
                      </div>
                  </div>}
                 
                  <div className='search-title login-text mt-3'>
                  <p className='line-height-xsnormal login-text mb-0'>
                    By signing in or signing up, I agree to <strong>MegaFit</strong>&nbsp;
                    <Link to='/terms' >Terms & Conditions</Link>, <Link to='/refunds' >Refund & Cancellation policy</Link>, <Link to='/privacy-policy' >Privacy Policy</Link>,
                    I confirm that I am 18 years of age or older, and consent to receiving email communication.
                  </p>
                  </div>
                  </div>
                  <div className='sign-up-input mt-3 sign-up-button d-flex align-items-center justify-content-around'>
                    <input type='submit' value={buttonText} className='form-button letter-sm w-100' />
                    {timer > 0 && `Wait ${timer}s`}
                  </div>
                </form>
              </div>
              {errorModalMessage &&
                <Modal
                  close={() => this.setState({ errorModalMessage: '' })}
                  message={errorModalMessage}
                />
              }
            </div>
          </div>  
          <div className='footer_bottom_copyrights'>
              <ul className="inline-list payment-icons footer__section">
                <li className="icon--payment master"><img src={MasterIcon} alt='Mastercard' /></li>
                <li className="icon--payment master"><img src={VisaIcon} alt='Visa' /></li>
              </ul>
              <ul className="footer-block__details-content list-unstyled">
                  <li><p className="footer_links_head font-weight-semibold">Help &amp; Info:</p></li>
                  <li><a href="https://megafit.ae/pages/delivery-policy" className="link link--text list-menu__item list-menu__item--link" target='_blank'>
                    Delivery Policy
                  </a></li>
                  <li><a href="https://megafit.ae/pages/privacy-policy" className="link link--text list-menu__item list-menu__item--link" target='_blank'>
                    Privacy Policy
                  </a></li>
                  <li><a href="https://megafit.ae/pages/refund-cancellation-policy" className="link link--text list-menu__item list-menu__item--link" target='_blank'>
                    Refund &amp; Cancellation Policy
                  </a></li>
                  <li><a href="https://megafit.ae/pages/terms-and-conditions" className="link link--text list-menu__item list-menu__item--link" target='_blank'>
                    Terms &amp; Conditions
                  </a></li>
                </ul>
            </div>     
        </div>
      </div>
      </div>
      </div>
    );
  }
}

OtpAuth.propTypes = {
  socket: PropTypes.object.isRequired,
  settings: PropTypes.object,
  browserId: PropTypes.string,
  login: PropTypes.func.isRequired
};

const props = state => ({
  browserId: state.user.browserId,
  language: state.user.language,
  settings: state.settings
});

const actions = dispatch => ({
  login: user => dispatch(userLogin(user)),
  spin: () => dispatch(spin()),
  stop: () => dispatch(stop()),
});

export default socketConnect(connect(props, actions)(OtpAuth));
